module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/thumbs/2-30103dd3a9a73c3459cde19cdc6d30b3.webp";